import { useContext } from "react";
import { PreparationReportsDashboardContext } from "./Preparation.provider";

export function usePreparationReportsDashboardContext() {
  const context = useContext(PreparationReportsDashboardContext);

  if (!context) {
    throw new Error("usePreparationDashboardContext deve ser utilizado apenas dentro de PreparationProvider")
  }

  return context
}